"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const reducer_1 = __importDefault(require("companion-app-components/flux/preferences/reducer"));
const types_1 = require("./types");
const localReducer = (state = types_1.initialPreferencesState) => state;
const reducerMerged = (state, action) => {
    const state1 = localReducer(state);
    const state2 = (0, reducer_1.default)(state1, action);
    return state2;
};
exports.default = reducerMerged;
